/* eslint-disable no-unused-vars */
import { Label } from '../../../../Components/uielements';
import {
  LoadingText,
  ModalButtonWrapper,
  OutlineButton,
} from '../../../../services/settings/appStyle/global.style';
import { IntlMessages } from '../../../../helper/langHelper';
import { useQuery } from 'react-query';
import ChildModal from '../../../../Components/uielements/modal/childModal';

import {
  viewCheckListAnsResponse,
  getCheckListDocument,
} from '../../../../services/bioplus-services/checkList';
import { ModalWrapper } from '../../EmailTemplate/emailTemplate.style';
import { useState } from 'react';
import {
  EmptyState,
  EmptyStateText,
  QuestionHeader,
  QuestionItem,
  QuestionsSection,
  QuestionText,
  QuestionTextWrapper,
  TypeBadge,
} from '../checkList.style';
import { Signature } from '../../LogRecordsV2/logRecords.style';

const ViewCheckListAnswers = ({ onClose, inviteId }) => {
  const [loadingDocId, setLoadingDocId] = useState(null);

  const query = useQuery(['checklist-answers', inviteId], () =>
    viewCheckListAnsResponse({ responseId: inviteId })
  );

  const responseData = query?.data?.response;

  const handleViewDocument = async (documentId) => {
    setLoadingDocId(documentId);

    try {
      const response = await getCheckListDocument({
        documentId: documentId,
        responseId: inviteId,
        listType: 'CHECKLIST',
      });
      if (response) {
        setLoadingDocId(null);
        window.open(response?.documentUrl, '_blank');
      }
    } catch (error) {
      setLoadingDocId(null);
      alert(error.message);
    }
  };

  const renderAnswer = (item) => {
    if (item.type === 'MEDIA') {
      const isLoading = loadingDocId === item.response;

      return (
        <TypeBadge
          as="button"
          onClick={() => handleViewDocument(item.response)}
          disabled={isLoading}
          style={{ cursor: 'pointer', padding: '8px 14px', maxWidth: 'fit-content', color: '#fff' }}
        >
          {isLoading ? (
            <>
              <IntlMessages id="loading.text" defaultMessage="Loading" />
              <LoadingText>...</LoadingText>
            </>
          ) : (
            <IntlMessages id="view.document" defaultMessage="View Document" />
          )}
        </TypeBadge>
      );
    }

    if (item.type === 'TEXTAREA') {
      return (
        <QuestionText style={{ whiteSpace: 'pre-wrap' }}>
          Ans. {item?.response || 'No answer provided'}
        </QuestionText>
      );
    }

    if (item.type === 'ACKNOWLEDGEMENT' && item.response) {
      return (
        <Signature
          src={`data:image/png;base64,${item.response.replace(
            /^data:application\/octet-stream;base64,/,
            ''
          )}`}
          alt="Signature"
        />
      );
    }

    return <QuestionText>Ans. {item?.response || 'No answer provided'}</QuestionText>;
  };

  return (
    <ChildModal
      isOpen={true}
      onClose={onClose}
      title={<IntlMessages id="modal.text.checklist.answers" />}
    >
      {query.isLoading ? (
        <ModalWrapper>
          <Label>
            <IntlMessages id="loading.text" />
          </Label>
        </ModalWrapper>
      ) : query.isError ? (
        <ModalWrapper>
          <Label>
            <IntlMessages id="error.message" />
          </Label>
          <ModalButtonWrapper>
            <OutlineButton onClick={onClose}>
              <IntlMessages id="modal.button.cancel" />
            </OutlineButton>
          </ModalButtonWrapper>
        </ModalWrapper>
      ) : (
        <ModalWrapper>
          {responseData.response.length > 0 ? (
            <QuestionsSection>
              {responseData.response.map((item, index) => (
                <QuestionItem key={item._id || item.id || index}>
                  <QuestionHeader>
                    <QuestionTextWrapper>
                      <QuestionText>
                        {item?.type !== 'ACKNOWLEDGEMENT' && `Q${index + 1}.`} {item.question}
                      </QuestionText>{' '}
                      {renderAnswer(item)}
                    </QuestionTextWrapper>
                  </QuestionHeader>
                </QuestionItem>
              ))}
            </QuestionsSection>
          ) : (
            <EmptyState>
              <EmptyStateText>No Answers found in this checklist.</EmptyStateText>
            </EmptyState>
          )}

          <ModalButtonWrapper>
            <OutlineButton onClick={onClose}>
              <IntlMessages id="modal.button.close" />
            </OutlineButton>
          </ModalButtonWrapper>
        </ModalWrapper>
      )}
    </ChildModal>
  );
};

export default ViewCheckListAnswers;
